__turbopack_context__.v({
  "footer": "otp-card-module-scss-module__eHG6ka__footer",
  "info": "otp-card-module-scss-module__eHG6ka__info",
  "input": "otp-card-module-scss-module__eHG6ka__input",
  "sub-title": "otp-card-module-scss-module__eHG6ka__sub-title",
  "title": "otp-card-module-scss-module__eHG6ka__title",
});
